exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-table{height:260px;overflow-y:auto;overflow-x:hidden}.head-stick th{background:#fff;position:sticky;top:-3px;box-shadow:0 2px 2px -1px rgba(0,0,0,.4);z-index:60!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dfedb992","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/Rencuestacultura.vue
// module id = 1083
// module chunks = 2